import React from 'react';
import { Header, Stack } from 'buzz_lib_ui';
import { jsx as _jsx } from "react/jsx-runtime";
const Loading = _ref => {
  let {
    env = 'prod'
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    children: /*#__PURE__*/_jsx(Header, {
      env: env,
      children: "Buzz > Loading module..."
    })
  });
};
export default Loading;